import React from 'react';
import { motion } from 'framer-motion';
export function Stats() {
  return <section className="py-24 bg-[#D4DDE8]" data-id="element-176">
      <div className="container mx-auto px-6" data-id="element-177">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-178">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="max-w-md" data-id="element-179">
            <p className="text-lg leading-relaxed text-primary-dark/80" data-id="element-180">
              AccuTemp is Nuneaton's leading commercial HVAC specialist. With
              over 16 years of experience and Daikin D1+ Premier Partner status,
              we deliver installation, maintenance, and compliance services that
              last.
            </p>
          </motion.div>

          <div className="grid grid-cols-2 gap-12" data-id="element-181">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} data-id="element-182">
              <div className="text-5xl md:text-6xl font-light mb-2" data-id="element-183">16+</div>
              <div className="text-sm text-primary-dark/60 uppercase tracking-wider" data-id="element-184">
                Years experience
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-185">
              <div className="text-5xl md:text-6xl font-light mb-2" data-id="element-186">0</div>
              <div className="text-sm text-primary-dark/60 uppercase tracking-wider" data-id="element-187">
                Manufacturer callbacks
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} data-id="element-188">
              <div className="text-5xl md:text-6xl font-light mb-2" data-id="element-189">1,000+</div>
              <div className="text-sm text-primary-dark/60 uppercase tracking-wider" data-id="element-190">
                Commercial projects
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} data-id="element-191">
              <div className="text-5xl md:text-6xl font-light mb-2" data-id="element-192">4-6wk</div>
              <div className="text-sm text-primary-dark/60 uppercase tracking-wider" data-id="element-193">
                Faster than rivals
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}